import React from "react";
import Select from "react-select";

const RYStepOne = ({ formData, handleChange, diseases }) => {
  return (
    <section>
      <div className="row">
        {/* First Name */}
        <div className="col-lg-6 mb-2">
          <label className="text-label">First Name <span style={{ color: "red" }}>*</span></label>
          <input
            type="text"
            name="first_name"
            className="form-control"
            value={formData.first_name}
            onChange={handleChange}
            placeholder="Enter First Name"
            required
          />
        </div>

        {/* Middle Name */}
        <div className="col-lg-6 mb-2">
          <label className="text-label">Middle Name </label>
          <input
            type="text"
            name="middle_name"
            className="form-control"
            value={formData.middle_name}
            onChange={handleChange}
            placeholder="Enter Middle Name"

          />
        </div>

        {/* Last Name */}
        <div className="col-lg-6 mb-2">
          <label className="text-label">Last Name <span style={{ color: "red" }}>*</span></label>
          <input
            type="text"
            name="lastname"
            className="form-control"
            value={formData.lastname}
            onChange={handleChange}
            placeholder="Enter Last Name"
            required
          />
        </div>

        {/* Contact Number */}
        <div className="col-lg-6 mb-2">
          <label className="text-label">Contact Number <span style={{ color: "red" }}>*</span></label>
          <input
            type="tel"
            name="contact_number"
            className="form-control"
            value={formData.contact_number}
            onChange={(e) => {
              const value =
                e.target.value
                  .replace(/\D/g, "")
                  .slice(0, 10);
              handleChange({
                target: {
                  name: "contact_number",
                  value,
                },
              });
            }}
            placeholder="Enter Contact Number"
            maxLength={10}
            required
          />
        </div>

        {/* Email */}
        <div className="col-lg-6 mb-2">
          <label className="text-label">Email Address <span style={{ color: "red" }}>*</span></label>
          <input
            type="email"
            name="email"
            className="form-control"
            value={formData.email}
            onChange={handleChange}
            placeholder="example@example.com"
            required
          />
        </div>

        {/* Diseases Select */}
        <div className="col-lg-6 mb-3">
          <label className="form-label">
            Disease <span style={{ color: "red" }}>*</span>
          </label>
          <Select
            options={(diseases || []).map((d) => ({
              value: d.disease_id.toString(),
              label: d.disease_name,
            }))}
            value={
              diseases
                ?.map((d) => ({
                  value: d.disease_id.toString(),
                  label: d.disease_name,
                }))
                .find((opt) => opt.value === formData.disease_id) || null
            }
            onChange={(selectedOption) =>
              handleChange({
                target: {
                  name: "disease_id",
                  value: selectedOption?.value || "",
                },
              })
            }
            placeholder="Select Disease"
            className="basic-single-select"
            classNamePrefix="select"
          />
        </div>
      </div>
    </section>
  );
};

export default RYStepOne;
